import { authenticate } from "../../modules/api";

const state = {
  ...parseToken(localStorage.CHLToken),
  org: {
    baseUrl: "",
    authUrl: "",
    orgName: "",
    orgId: "",
    crm: "",
    logoUrl: "",
    logoWidth: "",
    logoHeight: "",
    phone: "",
    website: "",
    shortName: "",
    serviceUrls: {},
  },
};

const getters = {
  userId(state) {
    return state.userId;
  },
  authState(state) {
    return {
      authState: state.authenticated,
      exp: state.expiration,
    };
  },
  loggedIn(state) {
    return state.authenticated === "ok" && state.expiration > Date.now();
  },
  baseUrl(state) {
    return state.org.baseUrl;
  },
  authUrl(state) {
    return state.org.authUrl;
  },
  organization(state) {
    return state.org;
  },
};

const mutations = {
  updateAuthState(state, { message, exp }) {
    state.authenticated = message;
    state.expiration = exp;
  },
  replaceAuthState(state, { userId, expiration, authenticated }) {
    state.userId = userId;
    state.expiration = expiration;
    state.authenticated = authenticated;
  },
  updateOrg(state, org) {
    state.org = { ...org };
  },
};

const actions = {
  async exchangeAuthToken({ commit, dispatch, rootGetters }, tmpToken) {
    await dispatch("fetchOrganization");
    let service = window.location.hostname === "localhost" ? "local" : rootGetters.organization.orgId;
    let res = await authenticate.exchangeToken(tmpToken, service);
    localStorage.CHLToken = res.data.token;
    const value = parseToken(res.data.token);
    commit("replaceAuthState", value);
    dispatch("init");
  },
  async fetchOrganization({ commit }) {
    let server = await authenticate.organization();
    commit("updateOrg", server.data.orgs[0]);
    // setPdfLogoUrl(server.data.orgs[0].logoUrl);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};

function parseToken(token) {
  if (!token) {
    return {
      authenticated: "",
      expiration: 0,
      userId: "",
    };
  }
  let split = token.split(".");
  if (split[1]) {
    try {
      let decoded = atob(split[1]);
      decoded = JSON.parse(decoded);
      return {
        authenticated: decoded.exp > Date.now() ? "ok" : "",
        expiration: decoded.exp,
        userId: decoded.id,
      };
    } catch (err) {
      return {
        authenticated: "",
        expiration: 0,
        userId: "",
      };
    }
  }

  return {
    authenticated: "",
    expiration: 0,
    userId: "",
  };
}
